// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/price-schema',
  type: 'object',
  required: ['netPrice', 'vatRate', 'vatAmount', 'grossPrice'],
  nullable: true,
  properties: {
    priceType: {
      type: 'string',
      nullable: true,
    },
    netPrice: {
      type: 'number',
    },
    vatRate: {
      type: 'number',
    },
    vatAmount: {
      type: 'number',
    },
    grossPrice: {
      type: 'number',
    },
  },
} as IJSONSchema;

export default schema;
